var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center min-h-screen text-center p-6 sm:p-0"},[_c('div',{staticClass:"fixed inset-0 bg-gray-500 bg-opacity-75",attrs:{"aria-hidden":"true"}}),_c('div',{staticClass:"fixed w-full h-full justify-center block top-0 left-0 z-50"},[_c('Main',[_c('LoginPrompt',{on:{"closePrompt":_vm.closePrompt}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }